import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { EmployeeService } from '../employee.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';

import { EmployeeDetails } from './employee-details.model';
import { Observable } from 'rxjs';
import { SessionService } from 'app/core/services/session.service';
import { ModalService } from 'app/core/services/modal.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { AuthService } from 'app/core/services/auth.service';

@Component({
  selector: 'itpx-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.css']
})
export class EmployeeDetailsComponent extends RxComponent implements OnInit {

    private details: EmployeeDetails;
    private sub: Subscription;
    private id: string;

    private fields: Array<any>;
    private buttons: Array<any>;
    private editButton = {
        title: 'Edit',
        action: 'edit',
        icon: 'fa-pencil-square',
        class: 'btn-primary',
        disabled: false
    };
    private backButton = {
        title: 'Back',
        action: 'back',
        icon: 'fa-arrow-left',
        class: 'btn-default',
        disabled: false
    };

    isInstructorCompany: boolean;
    isSellerAdmin: boolean;

    constructor(
        private employeeService: EmployeeService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router,
        private sessionService: SessionService,
        private modal: ModalService,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {

        this.details = new EmployeeDetails();
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            Observable.combineLatest(this.employeeService.getEmployeeDetails(this.id), this.employeeService.getAccountByDomain())
            .subscribe(
                ([a, b]) =>  {
                    this.extractData(a, b)
                }
            );
        });

        this.fields = this.employeeService.getDetailsFields();

        let details = this.sessionService.getUserDetails();
        let groups = details && details['groups'] && details['groups'].length;
        this.isSellerAdmin = groups && details['groups'].find(_ => _ === 'seller-admin');

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private extractData(employee: any, accountResp: any) {
        this.details = <EmployeeDetails>employee.data;
        let account = accountResp.data;

        if(this.details.instructor) {
            this.fields.splice(this.fields.length - 1, 0, {
                key: 'instructor',
                label: 'Instructor',
                type: 'boolean'
            })
        }
        let buttons = [this.backButton];
        if (this.employeeService.checkIfUserIsAdmin()) {
            buttons.push(this.editButton)
        };
        if(this.isSellerAdmin && !this.details.instructor)
            buttons.push({
                title: 'Promote to Instructor',
                action: 'promoteToInstructor',
                icon: 'fa-chalkboard-teacher',
                class: 'btn-primary',
                disabled: false
            });

        this.buttons = buttons;
    }

    private onAction(action: string) {
        if (action == 'edit') {
            this.router.navigate(['/organization/users/:id/edit', { id: this.id }]);
        } else if (action == 'back') {
            this.router.navigate(['/organization/users']);
        } else if (action == 'promoteToInstructor') {
            this.employeeService.promoteToInstructor(this.id)
                .subscribe(
                    _ => {


                        this.notificationService.success(
                            'Successfully promoted the employee to instructor',
                            'Success'
                        );
                        this.details = _.data;
                        this.fields.splice(this.fields.length - 1, 0, {
                            key: 'instructor',
                            label: 'Instructor',
                            type: 'boolean'
                        })
                        this.buttons = [this.editButton];

                        let selfPromote = _.data.email === this.sessionService.getUserDetails().username;

                        if(selfPromote)
                            this.modal.confirm('New sign in is required', 'To apply these changes you need to sign out and sign in again. ' +
                            'After that, you will be able to access your instructor profile from the top right corner of the screen.')
                                .neverError()
                                .bindToLifecycle(this)
                                .subscribe(
                                    async event => {
                                        await this.authService.logout();
                                    }
                                );
                    }
                );
        } else if (action == 'delete') {
            this.employeeService.delete(this.details)
                .subscribe(
                    data => {
                        this.notificationService.success(
                            'Successfully deleted Employee',
                            'Success'
                        );
                        this.router.navigate(['/organization/users']);
                    }
                );
        } else {
            return false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/employees/details/employee-details.component.ts